export default __webpack_public_path__ + "static/media/O-136.63cb8eea.png";